import { useSelector } from 'react-redux';

import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import { StoredPackRosterFilters } from '../types';
import { saveStoredPackRosterFilters } from '../utilsTyped';
import { fullStateSel } from './selectorsTyped';

export const useStorePackRosterFilter = () => {
  const rosterSliceState = useSelector(fullStateSel);
  const organizationGuid: string = useSelector(organizationGuidSel);

  return (stateModifications: Partial<StoredPackRosterFilters>) =>
    saveStoredPackRosterFilters(
      {
        ...rosterSliceState,
        ...stateModifications,
      },
      organizationGuid,
    );
};
